import { createUseStyles } from 'react-jss';
import { mechaColours } from 'ctm-components/components/mecha_components/mecha_styles';

export const useStyles = createUseStyles({
    summary_table_wrapper: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px',
        border: `1px solid ${mechaColours.lightBlue300}`,
        backgroundColor: 'white'
    },
    summary_title_wrapper: ({ isUpdated }) => ({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        borderBottom: '0px',
        backgroundColor: isUpdated ? mechaColours.lightBlue300 : mechaColours.backgroundPrimary,
        color: mechaColours.contentPrimary,
        padding: '0.8rem 1.6rem',
        fontSize: '1.4rem',
        fontWeight: '600',
        lineHeight: '165%'
    }),
    summary_title_verify_wrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        borderBottom: '0px',
        color: '#fff',
        backgroundColor: mechaColours.linkSecondary,
        padding: '0.8rem 1.6rem',
        fontSize: '1.4rem',
        fontWeight: '400',
        lineHeight: '165%',
        gap: '8px',
        height: '5.6rem'
    },
    title: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '0.6rem'
    },
    checkIcon: {
        height: '1.8rem',
        width: '1.8rem'
    },
    edit_button: {
        backgroundColor: 'transparent',
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        alignItems: 'center',
        gap: '0.4rem',
        cursor: 'pointer',
        '& > p': {
            margin: '0 auto',
            fontSize: '1.4rem',
            fontWeight: '600',
            textDecoration: 'underline',
            color: mechaColours.primary500
        }
    },
    summary_body_row: ({ isXs }) => ({
        display: 'flex',
        flexDirection: isXs ? 'column' : 'row',
        paddingLeft: '1.6rem',
        paddingRight: '1.6rem',
        borderBottom: `1px solid ${mechaColours.lightBlue300}`,
        paddingTop: '1.2rem',
        paddingBottom: '1.2rem'
    }),
    summary_body_row_verify: ({ isXs }) => ({
        display: 'flex',
        flexDirection: isXs ? 'column' : 'row',
        paddingLeft: '1.6rem',
        paddingRight: '1.6rem',
        borderBottom: `1px solid ${mechaColours.lightBlue300}`,
        paddingTop: '1.2rem',
        paddingBottom: '1.2rem',
        backgroundColor: '#FDFBF2',
        '& svg': {
            display: 'flex',
            alignSelf: 'center',
            height: '1em',
            width: '1em !important', // override inline styling
            backgroundColor: mechaColours.linkSecondary,
            borderRadius: '100%'
        }
    }),
    summary_body_row_final: {
        borderBottom: '0px !important'
    },
    row_container: {
        display: 'flex',
        flex: '1',
        justifyContent: 'space-between'
    },
    row_title: {
        fontSize: '1.4rem',
        fontWeight: '700',
        width: '22rem',
        color: mechaColours.linkSecondary
    },
    row_value: {
        fontSize: '1.4rem',
        marginBottom: '0rem',
        fontWeight: '500',
        flex: '80',
        color: mechaColours.linkSecondary
    },
    required_question_mark: {
        height: '1.6rem',
        width: '1.6rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignSelf: 'center'
    }
});
